import React, { useState } from 'react';

import { Form } from '@dashboard/components/Formik';
import useProduct from '../useProduct';

// `productId` targets a product outside the page (an order bump); omitted, it
// edits the page's own product.
const ProductDescriptionForm = ({ productId }) => {
  const { product, updateProduct } = useProduct(productId);
  const [isLoading, setIsLoading] = useState(false);

  if (!product) return null;

  return (
    <Form
      initialValues={{
        description: product.description,
      }}
      onSubmit={async (values, actions) => {
        const { data, error } = await updateProduct.mutateAsync(values);

        actions.resetForm({
          values: {
            description: data.description,
          },
        });

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'description',
          type: 'rich-text',
          placeholder: 'Describe what you’re selling',
          onLoading: setIsLoading,
        },
      ]}
      submitButton={{
        label: 'Save',
        disabled: isLoading,
      }}
    />
  );
};

export default ProductDescriptionForm;
